import React from "react";
import { useGlobalStore } from "@/store/hooks";
import { Modal, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import useSingleOrderDecryptedConsignee from "@/scenes/OrderManagement/hooks/useSingleOrderDecryptedConsignee";
import ShopType from "@/enum/ShopType";
import { getCurrentIsCanDecryptedShopType } from "@/utils/ShopUtils";
import OrderDTO from "@/dto/order/OrderDTO";
import ConsigneeDecryptTBButton from "./ConsigneeDecryptTBButton";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { isOrderWithEncryptedManualTag } from "@/utils/OrderTagUtils";
import Authority from "@/enum/Authority";

interface ConsigneeDecryptButtonProps {
    order: OrderDTO;

    onOrderUpdate?(orderId: number, order: Partial<OrderDTO>): void;
}

const ConsigneeDecryptButton: React.FC<ConsigneeDecryptButtonProps> = function (props) {
    const { order, onOrderUpdate } = props;

    const orderManagementStore = useOrderManagementStore();
    const globalStore = useGlobalStore();

    const shop = globalStore.shopMapping.get(order.shopId);

    const { runAsync: handleDecryptedConsignee, loading } = useSingleOrderDecryptedConsignee();

    if (loading) {
        return <span className="ml5 small text-light">加载中...</span>;
    }

    if (shop.type === ShopType.TAOBAO) {
        return (
            <ConsigneeDecryptTBButton
                shopId={order.shopId}
                onDecryptedConsigneeClick={async (type) => {
                    const pass = globalStore.checkUserAuthority(Authority.ROLE_ORDER_PRIVACY_CONSIGNEE_DECRYPT);

                    if (!pass) return;

                    const results = await handleDecryptedConsignee(order, type);

                    const result = results?.[0];

                    if (result) {
                        orderManagementStore?.table?.updateOrder?.(order.id, {
                            consignee: result.consignee,
                        });

                        onOrderUpdate?.(order.id, {
                            consignee: result.consignee,
                        });
                    }
                }}
            />
        );
    }

    if (getCurrentIsCanDecryptedShopType(shop.type)) {
        if (
            [ShopType.MANUAL, ShopType.INDEPENDENT_MANUAL].includes(shop.type) &&
            isOrderWithEncryptedManualTag(order)
        ) {
            return null;
        }

        return (
            <Tooltip title="点击查看完整信息">
                <a
                    role="button"
                    tabIndex={-1}
                    className="ml5 small text-light link-btn"
                    onClick={async (e) => {
                        e.preventDefault();

                        const pass = globalStore.checkUserAuthority(Authority.ROLE_ORDER_PRIVACY_CONSIGNEE_DECRYPT);

                        if (!pass) return;

                        const results = await handleDecryptedConsignee(order);

                        const result = results?.[0];

                        if (result) {
                            orderManagementStore?.table?.updateOrder?.(order.id, {
                                consignee: result.consignee,
                            });

                            onOrderUpdate?.(order.id, {
                                consignee: result.consignee,
                            });
                        }
                    }}
                    style={{ userSelect: "none" }}
                >
                    查看
                </a>
            </Tooltip>
        );
    }

    return null;
};

export default observer(ConsigneeDecryptButton);
